// src/components/Header.js
import React, { useState, useEffect } from "react";
import logo from "../assets/2.png";
import { useLocation, useNavigate } from "react-router-dom";
const Header = ({
  language,
  toggleLanguage,
  activeSection,
  // scrollToSection,
}) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const goToSection = (id) => {
    if (location.pathname !== "/") {
      navigate("/", { state: { section: id } });
    } else {
      scrollToSection(id);
    }
  };

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    el?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
    { id: "home", en: "Home", ar: "الرئيسية" },
    { id: "about", en: "About the Academy", ar: "حول الاكاديمية" },
    { id: "programs", en: "Training Programs", ar: "البرامج التدريبية" },
    { id: "education", en: "Continues Training", ar: "التدريب المستمر" },
    { id: "journal", en: "Academy Journal", ar: "مجلة الاكاديمية" },
    { id: "library", en: "Academy Library", ar: "مكتبة الاكاديمية" },
    { id: "contact", en: "Contact Us", ar: "اتصل بنا" },
  ];

  return (
    <header
      className={`fixed w-full z-50 transition-all duration-500 ${
        isScrolled
          ? "bg-green-900 shadow-lg py-2"
          : "bg-gradient-to-r from-green-800 to-green-900 py-4"
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-3 rtl:space-x-reverse">
            <div
              className="flex-shrink-0 p-2 rounded-lg cursor-pointer"
              onClick={() => {
                navigate("/");
              }}
            >
              {" "}
              {/* Added white background */}
              <img
                src={logo}
                alt="Arma Academy Logo"
                className="h-14 w-auto md:h-20 object-contain" // Fixed width issues
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "flex";
                }}
              />
              {/* Fallback logo in case image doesn't load */}
              {/* <div
                className="h-8 w-8 md:h-12 md:w-12 bg-white rounded-full flex items-center justify-center hidden"
                style={{ display: "none" }}
              >
                <span className="text-green-800 font-bold text-lg md:text-xl">
                  A
                </span>
              </div> */}
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8 rtl:space-x-reverse">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => goToSection(item.id)}
                className={`text-sm font-medium transition-all duration-300 ${
                  activeSection === item.id
                    ? "text-white border-b-2 border-green-300"
                    : "text-green-200 hover:text-white"
                }`}
              >
                {language === "ar" ? item.ar : item.en}
              </button>
            ))}
          </nav>

          {/* Language Toggle & Mobile Menu */}
          <div className="flex items-center space-x-4 rtl:space-x-reverse">
            <button
              onClick={() => {
                console.log("Clicked here");
                toggleLanguage();
              }}
              className="bg-white text-green-800 px-3 py-1 rounded-full text-sm font-medium hover:bg-green-100 transition-colors"
            >
              {language === "ar" ? "EN" : "AR"}
            </button>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden text-white"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                {mobileMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-green-700 pt-4">
            <div className="flex flex-col space-y-3">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => {
                    scrollToSection(item.id);
                    setMobileMenuOpen(false);
                  }}
                  className={`text-left py-2 px-4 rounded-lg transition-colors ${
                    activeSection === item.id
                      ? "bg-green-700 text-white"
                      : "text-green-200 hover:bg-green-800"
                  }`}
                >
                  {language === "ar" ? item.ar : item.en}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
